import React from 'react';
import { useNavigate } from 'react-router-dom';
import ThemeToggle from '../ThemeToggle';

const AuthHeader = () => {
  const navigate = useNavigate();

  return (
    <nav className="bg-background/80 backdrop-blur-sm border-b border-border shadow-sm fixed w-full top-0 z-10 transition-colors duration-200">
      <div className="max-w-6xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div 
            className="flex items-center cursor-pointer select-none" 
            onClick={() => navigate('/')}
          >
            <img src={process.env.PUBLIC_URL + "/thataihumanizer.svg"} alt="ThatAIHumanizer Logo" className="h-10 w-10 mr-3" />
            <span className="font-bold text-xl text-primary">ThatAIHumanizer</span>
          </div>
          
          <div className="flex items-center space-x-4">
            <button 
              onClick={() => navigate('/login')}
              className="text-primary hover:text-primary/80 font-medium px-3 py-1 select-none transition-colors"
              type="button"
            >
              Login
            </button>
            <button 
              onClick={() => navigate('/register')}
              className="bg-primary hover:bg-primary/90 text-primary-foreground font-medium py-2 px-4 rounded select-none transition-colors"
              type="button"
            >
              Register
            </button>
            <ThemeToggle />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default AuthHeader; 